<template>
  <div class="register">
    <div class="container">
      <div class="register__wrapper">
        <register-form />
      </div>
    </div>
  </div>
</template>

<script setup>
import RegisterForm from "@/components/forms/register-form.vue";
</script>

<style lang="scss" scoped>
.register {
  background-image: url(@images/authBg.png);
  background-repeat: no-repeat;
  background-size: cover;

  &__wrapper {
    padding-block: 100px 175px;
    display: grid;
    place-items: center;
  }
}
</style>